var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/isarray/index.js
// module id = d0pw
// module chunks = 0